<template>
  <div>
    <ClientOnly>
      <el-dialog
        v-model="isOpened"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        class="login-component"
        destroy-on-close
        width="400px">
        <div :class="$style['form-content']">
          <div
            :class="$style['close_icon']"
            @click="close">
            <el-icon>
              <Close />
            </el-icon>
          </div>
          <ju-login
            v-if="formType === FormType.login"
            @form-type-change="handleFormTypeChange" />
          <ju-forget
            v-else-if="formType === FormType.forget"
            @form-type-change="handleFormTypeChange" />
          <ju-register
            v-else-if="formType === FormType.register"
            @form-type-change="handleFormTypeChange" />
          <ju-bind
            v-else-if="formType === FormType.bind"
            @form-type-change="handleFormTypeChange" />
        </div>
      </el-dialog>
    </ClientOnly>
  </div>
</template>

<script lang="ts">
  import { defineAsyncComponent, defineComponent, ref } from 'vue'
  import { FormType } from './constant'
  import { Close } from '@element-plus/icons-vue'

  const Register = defineAsyncComponent(() => import('~/components/Login/components/register.vue'))
  const Bind = defineAsyncComponent(() => import('~/components/Login/components/bind.vue'))
  const Forget = defineAsyncComponent(() => import('~/components/Login/components/forget.vue'))
  const Login = defineAsyncComponent(() => import('~/components/Login/components/login.vue'))

  export default defineComponent({
    components: {
      Close,
      'ju-login': Login,
      'ju-forget': Forget,
      'ju-register': Register,
      'ju-bind': Bind
    },
    setup() {
      const isOpened = ref(false)
      const formType = ref(FormType.login)

      const handleFormTypeChange = (type: FormType) => {
        // console.log('64--')
        formType.value = type
      }

      // 关闭弹窗的方法
      const close = function () {
        isOpened.value = false
      }

      // 开启弹窗的方法
      // 这里准备了一个 opt 形参，用于开启弹窗时传入一些数据，你可以根据业务需要修改
      const open = (opt?: any) => {
        isOpened.value = true
      }

      return {
        isOpened,
        formType,
        handleFormTypeChange,
        close,
        open,
        FormType
      }
    }
  })
</script>

<style lang="less" module>
  .form-content {
    display: flex;
    background: #fff;
    width: max-content;
    min-width: 400px;
    min-height: 393px;
    border-radius: 8px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);
    box-sizing: border-box;
    padding: 35px 32px;
    position: relative;

    .close_icon {
      position: absolute;
      top: -20px;
      right: -38px;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background: #fff;
      cursor: pointer;

      i {
        color: #333;
        font-size: 20px;
      }
    }
  }
</style>

<style lang="less">
  .login-component {
    background: transparent;
    box-shadow: unset;

    .el-dialog {
    }

    .el-dialog__headerbtn {
      top: 48px;
      right: 16px;

      .el-icon-close {
        font-size: 20px;
      }
    }

    .el-dialog__body {
      padding: 0;
    }
  }
</style>
